import { get, isEmpty } from 'lodash';

export const buildTree = inventory => {
    const parents = [];
    const children = [];

    inventory.forEach(item => {
        const ParentId = get(item, 'parentId', '');

        if (isEmpty(ParentId)) {
            item.items = [];

            parents.push(item);
        } else {
            children.push(item);
        }
    });

    parents.forEach(parent => {
        const id = get(parent, 'id', '');

        children.forEach(child => {
            const parentId = get(child, 'parentId', '');

            if (id === parentId) {
                parent.items.push(child);
            }
        });
    });

    return parents;
};
